var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"text-center"},[_c('h2',[_vm._v(_vm._s(_vm.contract.title))])]),_vm._v(" "),_c('div',{domProps:{"innerHTML":_vm._s(_vm.contractMarkup)}}),_vm._v(" "),_c('br')])}
var staticRenderFns = []

export { render, staticRenderFns }